<template>
  <v-sheet elevation="2" class="px-12 py-8 rounded white">
    <div class="d-flex align-center pa-0 mb-6">
      <h6 class="h6">{{ $t('notifications.notification_other') }}</h6>

      <v-menu open-on-hover offset-x max-width="300" top>
        <template v-slot:activator="{ on }">
          <v-icon v-on="on" class="ml-1">
            mdi-help-circle-outline
          </v-icon>
        </template>

        <div class="grey darken-4 px-3 py-5 text-center">
          <p
            v-html="
              $sanitize($t('notifications.profile_help_center_tooltip'), {
                allowedTags: ['a'],
              })
            "
            class="text-body-2 white--text"
          />
        </div>
      </v-menu>
    </div>

    <form>
      <v-row class="mb-5">
        <v-col cols="1">
          <v-switch
            id="receive-email-notifications"
            class="ma-0 pa-0"
            :disabled="isLoading"
            :loading="isLoading"
            :input-value="form.receiveEmailNotifications"
            @click.stop="handleNotification('receiveEmailNotifications')"
          ></v-switch>
        </v-col>
        <v-col class="ms-2">
          <label
            class="body2 text-ui-800 ma-0 pa-0"
            for="receive-email-notifications"
          >
            {{ $t('notifications.receive_email_notifications') }}
          </label>
          <p class="pa-0 ma-0 text-ui-600 caption">
            {{ $t('notifications.receive_notifications_on_your_email') }}
          </p>
        </v-col>
      </v-row>

      <v-row class="mb-5">
        <v-col cols="1">
          <v-switch
            id="receive-push-notifications"
            class="ma-0 pa-0"
            :disabled="isLoading"
            :loading="isLoading"
            :input-value="form.receivePushNotifications"
            @click.stop="handleNotification('receivePushNotifications')"
          ></v-switch>
        </v-col>
        <v-col class="ms-2">
          <label
            class="body2 text-ui-800 ma-0 pa-0"
            for="receive-push-notifications"
            @click.stop="handleNotification('receivePushNotifications')"
          >
            {{ $t('notifications.receive_push_notifications') }}
          </label>
          <p class="pa-0 ma-0 text-ui-600 caption">
            {{
              $t(
                'notifications.receive_push_notifications_on_mobile_devices_you_log_in'
              )
            }}
          </p>
        </v-col>
      </v-row>
      <v-row class="mb-5">
        <v-col cols="1">
          <v-switch
            id="share-analytics"
            class="ma-0 pa-0"
            :disabled="isLoading"
            :loading="isLoading"
            :input-value="form.shareAnalytics"
            @click.stop="handleNotification('shareAnalytics')"
          ></v-switch>
        </v-col>
        <v-col class="ms-2">
          <label class="body2 text-ui-800 ma-0 pa-0" for="share-analytics">
            {{ $t('notifications.share_analytics_with_rever') }}
          </label>
          <p class="pa-0 ma-0 text-ui-600 caption">
            {{ $t('notifications.analytics_description') }}
          </p>
        </v-col>
      </v-row>
    </form>
  </v-sheet>
</template>

<script>
import mixin from '@/mixins/mixin.vue'

export default {
  name: 'Notifications',

  mixins: [mixin],

  props: {
    account: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      formIsValid: true,
      form: { ...this.account },
    }
  },

  methods: {
    handleNotification(notificationType) {
      this.form[notificationType] = !this.form[notificationType]
      this.$emit('update', this.form)
    },
  },
}
</script>
